module.exports = __webpack_public_path__ + "static/media/logo.b817a1a6.svg";